export default __webpack_public_path__ + "static/media/studio2.26befe87.jpeg";